// Import Dependencies
import styled from 'styled-components';

const Input = styled.input`
  left: -9999em;
  position: absolute;
`;

export default Input;
